import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { Reveal } from '@/components/landing/Reveal'
import { PageOutro, StatusChip, VisionSection, type Status } from '@/components/landing/Section'

/** The Roadmap page: what exists now, and what is still ahead. */
export function RoadmapPage() {
  return (
    <>
      <Roadmap />
      <PageOutro>
        <h2 className="nv-h2 text-[1.6rem] sm:text-[2rem]">Start with what already works</h2>
        <p className="mx-auto mt-3 max-w-xl text-[15px] leading-relaxed text-brand-body">Everything marked available today is in the version you can install right now.</p>
        {/* No "See what ships today" alongside it here: on the other pages that
            link leads to this one, but from the roadmap itself it pointed at
            the page the reader is already on. */}
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link to="/download" className="nv-btn-primary-lg">
            Download NevTan AI <ArrowRight size={16} />
          </Link>
        </div>
      </PageOutro>
    </>
  )
}

const ROADMAP: { status: Status; items: string[] }[] = [
  {
    status: 'today',
    items: [
      'Chat with local models, streamed as they are written',
      'A coding model built for programming questions',
      'Hardware detection, with a fit check for every model',
      'One-click download, switching, and removal',
      'Hosted models using your own API key',
    ],
  },
  {
    status: 'building',
    items: [
      'A searchable model hub with categories and ratings',
      'A wider catalog covering more model families',
      'Graphics card acceleration for faster answers',
      'Windows and Linux downloads',
    ],
  },
  {
    status: 'planned',
    items: [
      'Reasoning, vision, and document models',
      'Speech to text, and spoken replies',
      'Image, audio, and video generation',
      'Translation between languages, locally',
      'Answering questions from your own documents',
    ],
  },
]

function Roadmap() {
  return (
    <VisionSection
      id="roadmap"
      eyebrow="Where things stand"
      title="What exists now, and what is still ahead"
      lede="What you can rely on today, what we are building, and what comes next. Kept up to date as features ship."
    >
      <div className="grid gap-3 lg:grid-cols-3">
        {ROADMAP.map((column, index) => (
          <Reveal key={column.status} delay={index * 80}>
            <div
              className={`h-full rounded-xl border p-5 ${
                column.status === 'today'
                  ? 'border-brand/30 bg-brand-paper shadow-raised'
                  : 'border-brand-line bg-brand-paper shadow-card'
              }`}
            >
              <StatusChip status={column.status} />
              <ul className="mt-4 space-y-2.5">
                {column.items.map((item) => (
                  <li
                    key={item}
                    className="flex gap-2.5 text-[13.5px] leading-relaxed text-brand-body"
                  >
                    <span
                      className={`mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full ${
                        column.status === 'today' ? 'bg-brand' : 'bg-brand-line-strong'
                      }`}
                    />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </VisionSection>
  )
}

